const CACHE_PREFIX = 'app_cache_';
const DEFAULT_DURATION = 30 * 60 * 1000; // 30 phút

const loadAllCache = () => {
  try {
    const all = {};
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key.startsWith(CACHE_PREFIX)) {
        all[key] = JSON.parse(localStorage.getItem(key));
      }
    }
    return all;
  } catch (e) { return {}; }
};

let cacheStore = loadAllCache();

export const getCache = (key) => {
  const fullKey = CACHE_PREFIX + key;
  const cached = cacheStore[fullKey];
  if (cached && cached.timestamp > Date.now() - DEFAULT_DURATION) {
    return cached.data;
  }
  return null;
};

export const setCache = (key, data) => {
  const fullKey = CACHE_PREFIX + key;
  cacheStore[fullKey] = { data, timestamp: Date.now() };
  try { localStorage.setItem(fullKey, JSON.stringify(cacheStore[fullKey])); } catch (e) {}
};

export const clearCache = (key) => {
  const fullKey = CACHE_PREFIX + key;
  delete cacheStore[fullKey];
  try { localStorage.removeItem(fullKey); } catch (e) {}
};